<template>
  <div class="recipe-card">
    <div class="col-9 recipe-content">
      <h6 style="text-align: left;">{{ recipe.name }}</h6>
      <div class="recipe-card-list-tags">
        <span class="badge" v-for="tag in this.categories" :key="tag.id">{{ tag.nom }}</span>
      </div>
    </div>
    <img :src="getImagePath(recipe.photoName, recipe.photoUrl)" alt="Recipe Image" class="recipe-card-img">
  </div>
</template>

<script>
import FirebaseDataService from '../services/FirebaseDataService.js';

export default {
  name: 'RecipeCard',
  props: {
    recipe: Object
  },
  data() {
    return {
      categories: [],
      allCategories: [] // Store all available categories from Firebase
    };
  },
  async mounted() {
    await this.fetchAllCategories();
    this.fetchRecipeCategories();
  }, 
  watch: {
    recipe: {
      immediate: true,
      handler() {
        if (this.allCategories.length > 0) {
          this.fetchRecipeCategories();
        }
      }
    }
  },
  methods: {
    getImagePath(photoName, photoUrl = null) {
      if (!photoName) return '';
      
      // If there's a Firebase URL (new uploads), use it directly
      if (photoUrl && photoUrl.includes('firebase')) {
        return photoUrl;
      }
      
      // Otherwise, try to load from local assets (existing images)
      try {
        return require(`@/assets/images/${photoName}`);
      } catch (error) {
        // If local image doesn't exist and we have a URL, try that
        if (photoUrl) {
          return photoUrl;
        }
        return '';
      }
    },
    
    async fetchAllCategories() {
      try {
        this.allCategories = await FirebaseDataService.getCategories();
      } catch (error) {
        console.error('Error loading categories for RecipeCard:', error);
      }
    },
    
    fetchRecipeCategories() {
      if (!this.recipe || !this.recipe.categories) {
        console.log('RecipeCard: No recipe or categories data');
        this.categories = [];
        return;
      }
      
      console.log(`RecipeCard for "${this.recipe.name}": categories=${this.recipe.categories}, photoName=${this.recipe.photoName}, photoUrl=${this.recipe.photoUrl}`);
      
      this.categories = this.recipe.categories
        .map((categoryId) => {
          return this.allCategories.find(category => category.id === categoryId);
        })
        .filter(category => category !== undefined); // Remove undefined categories
        
      console.log(`RecipeCard "${this.recipe.name}": resolved categories=`, this.categories);
    }
  }
}

</script>

<style scoped>
.recipe-card {
  border-radius: 4%;
  padding: 8px;
  background-color: var(--light);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height:100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.recipe-card-img {
  border-radius: 4%;
  object-fit: cover;
  width: 70px;
  height: 70px;
}

.recipe-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.recipe-card-list-tags {
  display: flex;
  flex-wrap: wrap; 
  flex-direction: row;
}

.badge{
  background-color: var(--secondary);
  color: var(--primary);
  margin-right:5px;
  margin-top:3px;
}
</style>
